import { apiVersion } from '../apiVersion';
import * as methods from '../methods';
import { Resource } from '../Resource';
import plots from './plots';
const rootPath = 'measurements';
export const fromRaw = ({ id, device, plot, measurement_type, label, horizon, start_date, end_date, brand, model, distance_from }) => ({
    id,
    deviceId: device,
    plotId: plot,
    metric: measurement_type,
    label,
    horizon,
    startDate: start_date,
    endDate: end_date,
    brand,
    model,
    distance: distance_from
});
export const toRaw = ({ deviceId, endDate, horizon, id, label, metric, plotId, startDate }) => ({
    device: deviceId,
    end_date: endDate,
    horizon,
    id,
    label,
    measurement_type: metric,
    plot: plotId,
    start_date: startDate
});
const toRawEditHorizon = (newValue) => ({
    device: newValue.deviceId,
    plot: newValue.plotId,
    horizon: newValue.horizonId
});
const fromEditRaw = (savedValue) => [fromRaw(savedValue[0]), fromRaw(savedValue[1])];
const measurementsConfig = Resource((requesterBuilder, config) => {
    const getMany = (query) => requesterBuilder({
        path: `${rootPath}/plots/configs`,
        requestCtx: {
            params: {
                query: {
                    plot: query?.plotId,
                    measurement_types: query?.types,
                    since: query?.since,
                    before: query?.before
                }
            },
            transform: (results) => (results ? results.map(fromRaw) : []),
            ...apiVersion[1.1]
        }
    });
    return {
        plots: {
            getMany,
            changeHorizon: methods.create({
                rootPath: `${rootPath}/plots/configs/change_horizon`,
                fromRaw: fromEditRaw,
                requesterBuilder,
                toRaw: toRawEditHorizon,
                buildKeysToInvalidate: (plotId) => [
                    getMany().invalidationKey,
                    plots(requesterBuilder, config).get(plotId).invalidationKey
                ],
                patternToDelete: 'plots'
            })
        }
    };
});
export default measurementsConfig;
